import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

const styles = require('./pill.css');

/** Props for the component */
export interface PillProps {
  /** Additional classes to apply */
  className?: string;
  /** Bullet text */
  children: JSX.Element | string;
  kind: 'bordered' | 'filled' | 'overlaid';
}

/**
 * Pill item.
 */
@observer
export class Pill extends React.Component<PillProps> {
  /** Renders the component */
  render() {
    return (
      <div className={classnames(styles.pill, styles[this.props.kind], this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/widgets/pill/pill.tsx